
export default {
name: 'more',
components: {

},
data () {
return {

}
},
methods: {
goPage (pageName) {
this.$router.push({
path: '/'+pageName
})
}
},
created () {

},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/more/script.js